import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payroll-authorize-form',
  templateUrl: './payroll-authorize-form.component.html',
  styleUrls: ['./payroll-authorize-form.component.css']
})
export class PayrollAuthorizeFormComponent implements OnInit {
  title="Payroll Authorization";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/payroll-authorize/payroll-authorize-form/payroll-authorize-form.component.ts